import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux'

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, FormControlLabel, Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { setAdminUserStateAction } from "../../../appRedux/actions/adminUser";
import Iconify from '../../../components/iconify';
import { setUserTokenInLocal, setUserEssentials } from '../../../utils/storage'
// api
import { loginUserWithEmailAndPassword } from '../../../api/auth'
import { getCommonData } from '../../../api/superadmin/commonAPIs';
// ----------------------------------------------------------------------

export default function LoginForm({ setLoginState, setSnackbarMessage, setSnackbarOpen }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const path = window.location.pathname.split('/')[2]
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [showPassword, setShowPassword] = useState(false);
  const [inputs, setInputs] = useState({hospitalId: path === 'superadmin' ? '' : path } )
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(inputs);
    setIsLoading(true)
    try {
      const { data } = await loginUserWithEmailAndPassword(inputs);
      
      if (data.success) {
        setIsLoading(false)
        const result = await getCommonData(data.data.token);
        const userStateData = {
          "firstName": data.data.firstName,
          "lastName": data.data.lastName,
          "email": data.data.email,
          "role": data.data.role,
          "isSuperAdmin": data.data.isSuperAdmin 
        }
        setUserEssentials(userStateData);
        setUserTokenInLocal(data.data.token);
        dispatch(setAdminUserStateAction({
          user: userStateData,
          token: localStorage.getItem("token"),
          isAuthenticated: true,
          commonData: result.data.commondata,
        }))
        if(path === 'superadmin') {navigate('/dashboard', { replace: true }) }
        else {navigate('/request-dashboard', { replace: true }) }
               
        }
      else {

        setIsLoading(false)
        setSnackbarMessage({ msg: data.message, success: false })
        setSnackbarOpen(true)
        console.log('c');
      }

    }
     catch (error) {
      setIsLoading(false)
      setSnackbarMessage({ msg: error.message, success: false })
      setSnackbarOpen(true)
      console.log("err ", error);
    }


  };
  return (
    <Box component='form' onSubmit={handleSubmit} sx={{ width: '60%' }}>
      <Stack spacing={2} >
        <TextField
          required
          name="email"
          label="Email address"
          onChange={handleChange}
        />

        <TextField
          required
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Stack spacing={2}>
          <Link variant="subtitle2" underline="hover" onClick={() => { setLoginState(false) }} sx={{ cursor: 'pointer' }}>
            Forgot password?
          </Link>
          <LoadingButton loading={isLoading} fullWidth size="large" type="submit" variant="contained">
            Login
          </LoadingButton>
        </Stack>
      </Stack>

    </Box>
  );
}
